export default __webpack_public_path__ + "static/media/grimcorruption5.e5c2e093.png";